import flatten from 'lodash/flatten'
import get from 'lodash/get'
import { l } from '@manychat/manyui'

import { FlowChartConditionBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartConditionBuilder'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartCondition } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'
import { Field } from 'common/fields/entities/field'
import { Filter, FilterFieldOperatorData, Segment } from 'common/filter/interfaces'
import {
  FieldTypeOperator,
  FieldTypesOperators,
  FilterField,
} from 'common/filter/models/AudienceFilter/constants'
import formatFilterCondition from 'common/filter/models/AudienceFilter/formatters'
import { NotificationReason } from 'shared/api/common/schemas/notificationReason'

const unknownOperator: FilterFieldOperatorData = {
  value: FieldTypeOperator.UNKNOWN_OPERATOR,
  label: '?',
  display: '',
}

/**
 * This parser was extracted from old ConditionNode without any significant changes.
 * TODO: Optimize this parser TD-161
 */
export const parseConditions = (
  filter: Filter | null,
  {
    botTimezone,
    fields,
    segments,
    activeReasons,
  }: {
    botTimezone: string | null
    fields: Field[]
    segments: Record<string, Segment>
    activeReasons: NotificationReason[]
  },
): FlowChartCondition[] => {
  if (!filter) {
    return []
  }

  const { groups } = filter

  return flatten(
    groups.map(({ items }) =>
      items.map((condition): FlowChartCondition => {
        const { value, type, field } = condition

        if (type === 'tag' && !get(segments, `tag_${value}.active`, false)) {
          return new FlowChartConditionBuilder().withField(l.translate('Tag is missing')).build()
        }

        const isRnType = [
          FilterField.IG_RECURRING_NOTIFICATION_OPTIN,
          FilterField.IG_RECURRING_NOTIFICATION,
          FilterField.ONE_TIME_NOTIFICATION_OPTIN,
          FilterField.ONE_TIME_NOTIFICATION,
        ].includes(type as FilterField)

        if (isRnType) {
          const isActiveReasonExist = activeReasons.some((reason) => reason.reason_id === value)
          if (!isActiveReasonExist) {
            return new FlowChartConditionBuilder()
              .withField(l.translate('Notification Topic is missing'))
              .build()
          }
        }

        const fieldDesc = fields.find((f) => f.id === field)

        if (!fieldDesc) {
          return new FlowChartConditionBuilder().withField(l.translate('Field is missing')).build()
        }

        const operators: FilterFieldOperatorData[] = FieldTypesOperators[fieldDesc.type] || []
        const operatorValue = condition.operator || operators[0].value
        const operatorDesc = operators.find((op) => op.value === operatorValue) || unknownOperator

        operatorDesc.label = l.getString(operatorDesc.translatedLabel)
        operatorDesc.changedLabel = operatorDesc.translatedChangedLabel
          ? l.getString(operatorDesc.translatedChangedLabel)
          : operatorDesc.changedLabel
        const formattedValue = formatFilterCondition(value, fieldDesc, operatorDesc, segments, {
          botTimezone,
        })

        if (operatorDesc?.ignoreValue) {
          formattedValue[formattedValue.length - 1] = ''
        }

        return new FlowChartConditionBuilder()
          .withField(formattedValue?.[0] || null)
          .withCondition(formattedValue?.[1] || null)
          .withValue(
            formattedValue?.[2] ? replaceFieldsInString(formattedValue?.[2], fields) : null,
          )
          .build()
      }),
    ),
  )
}
